<div class="flex" style="height: 64px">
  <div class="card-icon">
    <i class="material-icons">{{ icon.icon }}</i>
  </div>
  <div class="d-flex align-items-center h-100">
    <h3 class="card-title">{{ icon.title }}</h3>
  </div>
</div>
